import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { API, axios } from '../../utils/api';
import { conteggio, giornoBreve } from '../../utils/documenti';
import Icona from '../../components/cliente/Icone';

// /admin/documenti (voce "Documenti" dello staff), nel nuovo stile: tutte le pratiche con quanto manca, cosa c'è da
// verificare, richieste aperte, ultimo invio e prossima scadenza. Apri porta alla scheda Documenti del cliente
// (admin e collaboratori); in alto l'archivio. Dati: GET /api/pratiche-documenti.

const FILTRI = [['tutte', 'Tutte'], ['verificare', 'Da verificare'], ['mancano', 'Mancano documenti'], ['richieste', 'Richieste aperte']];

const PROVA = { verificare: (p) => p.da_verificare > 0, mancano: (p) => p.mancano > 0, richieste: (p) => p.richieste_aperte > 0 };

const Documenti = () => {
  const [pratiche, setPratiche] = useState(null);
  const [errore, setErrore] = useState(false);
  const [giro, setGiro] = useState(0);
  const [cerca, setCerca] = useState('');
  const [solo, setSolo] = useState('tutte');
  // Se il server non risponde NON si finge una lista vuota: prima `catch(() => setPratiche([]))` faceva leggere
  // «Nessuna pratica qui» e quattro zeri, e chi guardava chiudeva la pagina convinto di non avere niente da fare
  // (blocco 4, primo giro).
  useEffect(() => {
    let vivo = true;
    axios.get(`${API}/pratiche-documenti`)
      .then((r) => { if (vivo) { setErrore(false); setPratiche(r.data); } })
      .catch(() => { if (vivo) { setPratiche(null); setErrore(true); } });
    return () => { vivo = false; };
  }, [giro]);
  const visibili = useMemo(() => (pratiche || []).filter((p) => {
    if (cerca && !p.nome.toLowerCase().includes(cerca.toLowerCase())) return false;
    return PROVA[solo] ? PROVA[solo](p) : true;
  }), [pratiche, cerca, solo]);
  const verificare = (pratiche || []).reduce((n, p) => n + p.da_verificare, 0);
  const aspettano = (pratiche || []).filter((p) => p.mancano > 0).length;
  const conta = {
    tutte: (pratiche || []).length,
    verificare: (pratiche || []).filter(PROVA.verificare).length,
    mancano: aspettano,
    richieste: (pratiche || []).filter(PROVA.richieste).length,
  };

  return (
    <main className="st wrap pagina-documenti" data-testid="pratiche-documenti">
      <div className="head r" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: '1rem', flexWrap: 'wrap', marginBottom: '1.2rem' }}>
        <div>
          <div className="k">Pratiche</div>
          {/* con il server giù i numeri non si inventano: un trattino, come nella lista dei clienti */}
          <h1>Documenti · <em>{errore ? '—' : `${verificare} da verificare`}</em></h1>
          <p>{errore ? 'Non riesco a leggere le pratiche.'
            : `${aspettano === 1 ? '1 pratica aspetta' : `${aspettano} pratiche aspettano`} documenti dal cliente.`}</p>
        </div>
        <Link className="btn" to="/admin/archivio"><Icona nome="documento" />Archivio</Link>
      </div>
      <div className="cl-tools r" style={{ marginBottom: '.9rem' }}>
        {FILTRI.map(([v, t]) => (
          <button type="button" key={v} className={`chip${solo === v ? ' on' : ''}`} aria-pressed={solo === v} onClick={() => setSolo(v)}>{t} <b>{errore ? '—' : conta[v]}</b></button>
        ))}
        <label className="srch"><Icona nome="cerca" /><input value={cerca} onChange={(e) => setCerca(e.target.value)} placeholder="Cerca un cliente" aria-label="Cerca un cliente" /></label>
      </div>
      <div className="tbl r">
        <div className="tr testa doc"><div>Cliente</div><div>Da verificare</div><div>Mancano</div><div>Ultimo invio</div><div>Scadenza</div><div /></div>
        {!pratiche && !errore && <div className="tr tutti"><span className="muto">Carico le pratiche…</span></div>}
        {errore && (
          <div className="tr tutti" data-testid="pratiche-errore">
            <span className="muto" role="alert">Non riesco a caricare le pratiche.{' '}
              <button type="button" onClick={() => setGiro((g) => g + 1)}>Riprovate</button>
            </span>
          </div>
        )}
        {pratiche && !visibili.length && <div className="tr tutti"><span className="muto">Nessuna pratica {cerca ? `per “${cerca}”` : 'qui'}.</span></div>}
        {visibili.map((p) => (
          <div className="tr doc" key={p.cliente_id} data-testid={`pratica-${p.cliente_id}`}>
            <div className="nm"><div className="av">{(p.nome || '?')[0]}</div><div style={{ minWidth: 0 }}><b>{p.nome}</b>
              {/* singolare e plurale: prima "1 richieste aperte" e "1 ricevuti" */}
              <span>{[p.mancano ? `${p.mancano === 1 ? 'manca' : 'mancano'} ${p.mancano}` : 'niente da chiedere',
                conteggio(p.ricevuti || 0, 'ricevuto', 'ricevuti'),
                p.richieste_aperte ? conteggio(p.richieste_aperte, 'richiesta aperta', 'richieste aperte') : null].filter(Boolean).join(' · ')}</span></div></div>
            <div className={`lt${p.da_verificare ? ' w' : ''}`}>{p.da_verificare || '—'}</div>
            <div className="nx">{p.mancano ? `${p.mancanti.slice(0, 3).join(', ')}${p.mancanti.length > 3 ? '…' : ''}` : <span className="muto">—</span>}</div>
            <div className="nx">{p.ultimo_invio ? <>{p.ultimo_invio.ente}<span>il {giornoBreve(p.ultimo_invio.data)}</span></> : <span className="muto">—</span>}</div>
            <div className="nx">{p.prossima_scadenza ? giornoBreve(p.prossima_scadenza) : <span className="muto">—</span>}</div>
            <Link className={`btn sm${p.da_verificare ? ' p' : ''}`} to={`/admin/clienti/${p.cliente_id}#documenti`}
              aria-label={`Apri la pratica di ${p.nome}`}>Apri</Link>
          </div>
        ))}
      </div>
    </main>
  );
};

export default Documenti;
